
import IconClose from '../../icons/icon-close/index.vue';
import { lockScroll } from  '../../utils/lockScroll.js';
// import {SET_MODAL_WINDOW_STATE} from '../store/mutations.types';

export default {
  name: 'rzModalWindowMobile',
  components: {
    IconClose,
  },
  mixins: [lockScroll],
  props: {
    bgPageColor: Boolean,
    headerBordered: Boolean,
    withoutClose: Boolean,
    night: Boolean,
  },
  data() {
    return {
      offset: 0,
    };
  },
  mounted() {
    if (window) {
      this.offset = window.pageYOffset;
    }
    this.$emit('mounted');
    const body = document.querySelector('body');
    let scrollPosition = 0;
    scrollPosition = window.pageYOffset;
    body.style.overflow = 'hidden';
    body.style.position = 'fixed';
    body.style.top = `-${scrollPosition}px`;
    body.style.width = '100%';
    // this.$store.commit(SET_MODAL_WINDOW_STATE, true);
  },
  destroyed() {
    const body = document.querySelector('body');
    body.style.removeProperty('overflow');
    body.style.removeProperty('position');
    body.style.removeProperty('top');
    body.style.removeProperty('width');
    window.scrollTo(0, this.offset);
    // this.$store.commit(SET_MODAL_WINDOW_STATE, false);
  },
  methods: {
    closeWindow(e) {
      e.preventDefault();
      this.$emit('close');
    },
  },
};
